import styled, { css } from 'styled-components';
import { Size } from './avatar.types';

function getDimensions(size: Size) {
  switch (size) {
    case 'sm':
      return { width: '24px', height: '24px', 'border-radius': '24px' };
    case 'md':
      return { width: '32px', height: '32px', 'border-radius': '32px' };
    case 'lg':
      return { width: '40px', height: '40px', 'border-radius': '40px' };
    default:
      return { width: '24px', height: '24px', 'border-radius': '24px' };
  }
}

function getFontSize(size: Size) {
  switch (size) {
    case 'sm':
      return 't4';
    case 'md':
      return 't2';
    case 'lg':
      return 't2';
    default:
      return 't4';
  }
}

export const Container = styled.div<{ $backgroundColor: string; $size: Size }>(
  ({ $size, $backgroundColor, theme: { color, font } }) => css`
    ${font[getFontSize($size)]};
    background-color: ${$backgroundColor};
    color: ${color.ui7};
    ${getDimensions($size)};

    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
  `,
);

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
